import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  addNotificationTemplate,
  getNotificationtemplatebyId,
  getNotificationTypeList,
  updateNotifitionTemplate
} from "../../redux/services/notificationTemplate.service";
import { getTemplateTokenList } from "../../redux/services/documentTemplate.service";
import { Controller, useForm } from "react-hook-form";
import { Button, Form, Container, Card, Row, Col } from "react-bootstrap";
import HTMLEditor from "../../components/common/HTMLEditor";
import ButtonComp from "../../components/common/Button";
import CommonDropdown from "../../components/common/CommonDropdown";
import { toast } from "react-toastify";

const NotificationTemplateForm = () => {
  const navigate = useNavigate();
  const [template, setTemplate] = useState("");
  const [templateKeys, setTemplateKeys] = useState([]);
  const [notificationTypeList, setNotificationTypeList] = useState([]);
  const { id } = useParams();
  const editorRef = useRef(null);
  const urlRef = useRef(null);
  const activeRef = useRef("");

  const {
    control,
    reset,
    setValue,
    handleSubmit,

    formState: { errors, isSubmitting }
  } = useForm({});

  useEffect(() => {
    const loadData = async () => {
      try {
        const [templateKeysRes, notificationTypeRes] = await Promise.all([
          getTemplateTokenList(true),
          getNotificationTypeList()
        ]);
        if (id) {
          const notificaticationtemplateRes = await getNotificationtemplatebyId(id);
          if (notificaticationtemplateRes) {
            reset(notificaticationtemplateRes);
          }
          setTemplate(notificaticationtemplateRes.notificationText);
        }
        setTemplateKeys(templateKeysRes);
        setNotificationTypeList(notificationTypeRes);
      } catch (error) {
        console.error(error);
      }
    };
    loadData();
  }, [id, reset]);

  const onSubmit = async (data) => {
    try {
      const payload = {
        ...data,
        NotificationText: template
      };
      const response = id
        ? await updateNotifitionTemplate(payload)
        : await addNotificationTemplate(payload);

      if (response.statusCode === 200) {
        toast.success(`Notification Template ${id ? "updated" : "saved"} successfully!`);
        navigate("/notificationtemplate");
      }
    } catch (error) {
      const message = error?.response?.data?.message || "Something went wrong";
      toast.error(message);
    }
  };

  const insertParameter = (token) => {
    if (!token) return;

    if (activeRef.current === "url") {
      const input = urlRef.current;

      const start = input.selectionStart;
      const end = input.selectionEnd;

      const newValue = input.value.substring(0, start) + token + input.value.substring(end);

      setValue("notificationURL", newValue);

      setTimeout(() => {
        input.focus();
        input.setSelectionRange(start + token.length, start + token.length);
      }, 0);
    } else if (activeRef.current === "editor") {
      editorRef.current.model.change((writer) => {
        editorRef.current.model.insertContent(
          writer.createText(token),
          editorRef.current.model.document.selection
        );
      });
    }
  };
  const buttonText = id > 0 ? "Save" : "Submit";
  return (
    <Container fluid className="py-4">
      <div className="row">
        <div className="col-md-8">
          <h2> {id ? "Edit" : "Add "} Notification Templates</h2>
        </div>

        <div className="col-md-4 text-md-end">
          <Button className="btn btn-secondary" onClick={() => navigate(-1)}>
            <i className="pi pi-arrow-left"></i> Back
          </Button>
        </div>
      </div>
      <Card className="shadow-sm border-0">
        <Card.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row className="g-4">
              <Col md={6}>
                <Controller
                  name="notificationName"
                  control={control}
                  rules={{
                    required: "Notification Name is Required",
                    maxLength: {
                      value: 50,
                      message: "Maximum 50 characters allowed"
                    },
                    validate: (value) => value.trim().length > 0 || "Notification Name is Required"
                  }}
                  render={({ field }) => (
                    <>
                      <Form.Label>
                        Notification Name <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        {...field}
                        isInvalid={!!errors.notificationName}
                        placeholder="Please enter Notification Name"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.notificationName?.message}
                      </Form.Control.Feedback>
                    </>
                  )}
                />
              </Col>

              <Col md={6}>
                <Controller
                  name="notificationKey"
                  control={control}
                  rules={{
                    required: "Notification Key is Required",
                    maxLength: {
                      value: 50,
                      message: "Maximum 50 characters allowed"
                    },
                    validate: (value) => value?.trim()?.length > 0 || "Notification Key is Required"
                  }}
                  render={({ field }) => (
                    <>
                      <Form.Label>
                        Notification Key <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        {...field}
                        isInvalid={!!errors.notificationKey}
                        placeholder="Please enter Notification Key"
                        disabled={id ? true : false}
                        onKeyDown={(e) => {
                          if (e.key === " ") {
                            e.preventDefault();
                          }
                        }}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.notificationKey?.message}
                      </Form.Control.Feedback>
                    </>
                  )}
                />
              </Col>

              <Col md={6}>
                <Form.Label>Notification Parameter</Form.Label>
                <CommonDropdown
                  options={templateKeys || []}
                  value={null}
                  getOptionLabel={(option) => option.tokenName}
                  getOptionValue={(option) => option.token || option.token}
                  placeholder="Select Parameter"
                  onChange={(option) => insertParameter(option.token)}
                />
              </Col>

              <Col md={6}>
                <Form.Label>Notification Type</Form.Label>
                <span style={{ color: "red" }}> *</span>

                <Controller
                  name="notificationTypeId"
                  control={control}
                  rules={{
                    required: "Notification Type is required"
                  }}
                  render={({ field }) => (
                    <CommonDropdown
                      options={notificationTypeList ?? []}
                      getOptionLabel={(option) => option.notificationType}
                      getOptionValue={(option) => option.token || option.notificationTypeMasterId}
                      placeholder="Select Notification Type"
                      value={
                        notificationTypeList?.find(
                          (option) => option.notificationTypeMasterId === field.value
                        ) || null
                      }
                      onChange={(selectedOption) =>
                        field.onChange(selectedOption?.notificationTypeMasterId ?? null)
                      }
                    />
                  )}
                />

                {errors.notificationTypeId && (
                  <span className="text-danger">{errors.notificationTypeId.message}</span>
                )}
              </Col>

              <Col md={6}>
                <Controller
                  name="notificationURL"
                  control={control}
                  rules={{
                    required: "Notification URL is Required",
                    maxLength: {
                      value: 500,
                      message: "Maximum 500 characters allowed"
                    },
                    validate: (value) => value.trim().length > 0 || "Notification URL is Required"
                  }}
                  render={({ field }) => (
                    <>
                      <Form.Label>
                        Notification URL <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        {...field}
                        isInvalid={!!errors.notificationURL}
                        placeholder="Please enter Notification URL"
                        ref={(e) => {
                          field.ref(e);
                          urlRef.current = e;
                        }}
                        onFocus={() => (activeRef.current = "url")}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.notificationURL?.message}
                      </Form.Control.Feedback>
                    </>
                  )}
                />
              </Col>

              <Col md={6}>
                <Controller
                  name="description"
                  control={control}
                  rules={{
                    required: "Notification Description is Required",
                    maxLength: {
                      value: 500,
                      message: "Maximum 500 characters allowed"
                    },
                    validate: (value) =>
                      value?.trim()?.length > 0 || "Notification Description is Required"
                  }}
                  render={({ field }) => (
                    <>
                      <Form.Label>
                        Description <span className="text-danger">*</span>
                      </Form.Label>

                      <Form.Control
                        {...field}
                        as="textarea"
                        rows={1}
                        maxLength={500}
                        isInvalid={!!errors.description}
                        placeholder="Please enter Notification Description"
                      />

                      <div className="text-end small text-muted">
                        {field.value?.length || 0}/500
                      </div>

                      <Form.Control.Feedback type="invalid">
                        {errors.description?.message}
                      </Form.Control.Feedback>
                    </>
                  )}
                />
              </Col>

              <Col md={6}>
                <Form.Label className="fw-semibold">Notification Editor</Form.Label>
                <div className="border rounded">
                  <HTMLEditor
                    value={template}
                    onChange={(data) => setTemplate(data)}
                    editorReady={(editor) => {
                      editorRef.current = editor;

                      editor.editing.view.document.on("focus", () => {
                        activeRef.current = "editor";
                      });
                    }}
                    style={{ height: "350px", width: "100%" }}
                  />
                </div>
              </Col>
              <Col md={6}>
                <Form.Label className="fw-semibold">Notification Preview</Form.Label>
                <div
                  className="border rounded  p-3 ck-content preview-container"
                  style={{ minHeight: "415px", overflowY: "scroll" }}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: template
                    }}
                  />
                </div>
              </Col>
              <Col xs={12}>
                <div className="d-flex justify-content-end gap-2">
                  <ButtonComp
                    buttonType="submit"
                    isSubmitting={isSubmitting}
                    style={{ margin: "0px" }}
                    buttonText={buttonText}
                  />
                  {/* <Button type="submit" disabled={isSubmitting}>
                    {isSubmitting ? (
                      <>
                        <Spinner size="sm" className="me-2" />
                        Processing...
                      </>
                    ) : id > 0 ? (
                      "Update"
                    ) : (
                      "Submit"
                    )}
                  </Button> */}
                </div>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};
export default NotificationTemplateForm;
